import { defineComponent as _defineComponent } from 'vue'
import TimeAxisSpanButton from '@/components/TimeAxisSpanButton.vue';
import QuickSearchButton from '@/components/QuickSearchButton.vue';
import TargetsMenu from '@/components/TargetsMenu.vue';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import AggregatesMenu from '@/components/AggregatesMenu.vue';
import ThreeDotParamEntry from './ThreeDotParamEntry.vue';
import { TargetsMetric } from '@/models/enums/TargetsMetric';
import QuickSearchItem from '@/models/metrics/quickSearchItem';
import { Params } from '@/models/enums/WidgetEnum';
import { Aggregate } from '@/models/metrics/aggregates';
import { computed, ref } from 'vue';
import { isNil } from '@/utils/misc';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ThreeDotsOptions',
  props: {
    targets: null,
    aggregates: null,
    hasAxisSpanFilter: { type: Boolean, default: false },
    hasDownload: { type: Boolean, default: false },
    hasAggregates: { type: Boolean, default: false },
    hasTargets: { type: Boolean, default: false },
    innerMenuPosition: { default: 'is-right' },
    chosenTimespan: { default: FilterTimeAxisSpanEnum.Day },
    targetsMetric: { default: null },
    params: null,
    paramValues: null,
    quickSearchFunction: null
  },
  emits: ["download-data", "target-change", "quick-search-select", "time-change", "aggregates-change", "param-update"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'download-data'): void;
  (e: 'target-change', value: number[]): void;
  (e: 'quick-search-select', value: QuickSearchItem): void;
  (e: 'time-change', value: number): void;
  (e: 'aggregates-change', value: Aggregate[]): void;
  (e: 'param-update', value: { [key: string]: any }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { targets?: number[], aggregates?: Aggregate[], hasAxisSpanFilter: boolean, hasDownload: boolean, hasAggregates: boolean, hasTargets: boolean, innerMenuPosition: string, chosenTimespan: FilterTimeAxisSpanEnum, targetsMetric: TargetsMetric | null, params?: Params, paramValues?: { [key: string]: any }, quickSearchFunction?: () => Promise<QuickSearchItem[]> };





const targetsMenuRef = ref<InstanceType<typeof TargetsMenu>>();
const timeAxisSpanButtonRef = ref<InstanceType<typeof TimeAxisSpanButton>>();
const aggregatesMenuRef = ref<InstanceType<typeof AggregatesMenu>>();

const { t } = useI18n();

function toggleTargetsMenu() {
  targetsMenuRef.value?.toggle();
}

function toggleTimeAxisSpanButton() {
  timeAxisSpanButtonRef.value?.toggle();
}

function toggleAggregateButton() {
  aggregatesMenuRef.value?.toggle();
}

function targetChange(targets: number[]) {
  emit('target-change', targets);
}

function downloadData() {
  emit('download-data');
}

function hasParams(): boolean {
  return !!props.params;
}

const hasQuickSearch = computed(() => !isNil(props.quickSearchFunction));

const onlyShowsParams = computed(
  () =>
    !(
      props.hasDownload ||
      props.hasTargets ||
      hasQuickSearch.value ||
      props.hasAxisSpanFilter ||
      props.hasAggregates
    ) && hasParams(),
);

return { __sfc: true,props, emit, targetsMenuRef, timeAxisSpanButtonRef, aggregatesMenuRef, t, toggleTargetsMenu, toggleTimeAxisSpanButton, toggleAggregateButton, targetChange, downloadData, hasParams, hasQuickSearch, onlyShowsParams, TimeAxisSpanButton, QuickSearchButton, TargetsMenu, AggregatesMenu, ThreeDotParamEntry }
}

})